// 应用配置 - 基于域名自动选择配置
const hostname = window.location.hostname;

// 配置映射表
const configs = {
  // 本地开发环境
  'localhost': {
    AZURE_AD_TENANT_ID: '72f988bf-86f1-41af-91ab-2d7cd011db47',
    AZURE_AD_CLIENT_ID: '60449ad6-a457-4a18-b78e-6c28cae2b6c1',
    API_BASE_URL: 'http://localhost:3001/api'
  },
  '127.0.0.1': {
    AZURE_AD_TENANT_ID: '72f988bf-86f1-41af-91ab-2d7cd011db47',
    AZURE_AD_CLIENT_ID: '60449ad6-a457-4a18-b78e-6c28cae2b6c1',
    API_BASE_URL: 'http://localhost:3001/api'
  },
  // 生产环境 - 默认配置
  // 如果你的生产域名是 'lego.example.com'，可以添加：
  // 'lego.example.com': { ... },
  'default': {
    AZURE_AD_TENANT_ID: '72f988bf-86f1-41af-91ab-2d7cd011db47',
    AZURE_AD_CLIENT_ID: '60449ad6-a457-4a18-b78e-6c28cae2b6c1',
    API_BASE_URL: '/api'
  }
};

// 选择配置
const config = configs[hostname] || configs['default'];

console.log('[Config] Loaded configuration for hostname:', hostname);
console.log('[Config] Using config:', config);

// 导出配置
export const APP_CONFIG = config;

// 也设置到 window 以便其他地方访问
window.APP_CONFIG = config;